import {
    allFetch
} from "../Domain";

/**
 * @description PDI工作站
 */
export const PDIWorkstation = (() => {
    /**
     * @description 新增工作站 
     * @param {string} pdi_ws_name      工作站名稱
     * @param {string} note             備註
     * @param {string} cars_per_day     每天最多可處理幾幾台車
     * @param {string} hours_per_car    每台車最多要花幾小時
     * @param {string} seq              排序
     * @param {string} is_custody_only  限制站台預約人
     * @returns res
     */
    const PDIWorkstationCreate = async (obj = {
        pdi_ws_name: '',
        note: '',
        cars_per_day: '',
        hours_per_car: '',
        seq: '',
        is_custody_only: ""
    }) => await allFetch('PDIWorkstation/PDIWorkstationCreate', obj);


    /**
     * @description 修改工作站
     * @param {string} pdi_ws_id        工作站流水號
     * @param {string} pdi_ws_name      工作站名稱
     * @param {string} note             備註
     * @param {string} cars_per_day     每天最多可處理幾幾台車
     * @param {string} hours_per_car    每台車最多要花幾小時
     * @param {string} visible          是否可見
     * @param {string} seq              排序
     * @param {string} is_custody_only  限制站台預約人
     * @returns res
     */
    const PDIWorkstationUpdate = async (obj = {
        pdi_ws_id: '',
        pdi_ws_name: '',
        note: '',
        cars_per_day: '',
        hours_per_car: '',
        visible: '',
        seq: '',
        is_custody_only: ""
    }) => await allFetch('PDIWorkstation/PDIWorkstationUpdate', obj);

    /**
     * @description 查詢工作站
     * @param {string} pdi_ws_name      工作站名稱
     * @param {string} visible          是否可見
     * @param {string} is_custody_only  限制站台預約人
     * @param {number} page             頁碼
     * @param {number} num_per_page     一頁幾筆
     * @returns res
     */
    const PDIWorkstationSearch = async (obj = {
        pdi_ws_name: '',
        visible: '',
        is_custody_only: "",
        page: 0,
        num_per_page: 10
    }) => await allFetch('PDIWorkstation/PDIWorkstationSearch', obj);

    /**
     * @description 工作站細項
     * @returns res
     */
    const PDIWorkstationDetail = async (obj = {
        pdi_ws_id: ""
    }) => await allFetch('PDIWorkstation/PDIWorkstationDetail', obj);

    /**
     * @description 刪除工作站
     * @returns res
     */
    const PDIWorkstationDelete = async (obj = {
        pdi_ws_id: ""
    }) => await allFetch('PDIWorkstation/PDIWorkstationDelete', obj);

    return {
        PDIWorkstationCreate,
        PDIWorkstationUpdate,
        PDIWorkstationSearch,
        PDIWorkstationDetail,
        PDIWorkstationDelete,
    };
})()